/**
 * Singular / plural for Judge.me review counts.
 *
 * Judge.me renders its badges from a product metafield using one text template
 * ("( {{ number_of_reviews }} reviews )") with no singular form. The count is on the
 * markup as data-number-of-reviews, so the word is chosen from the number:
 * more than one -> "reviews", otherwise -> "review" (0 and 1 both singular, as asked).
 *
 * Judge.me sets the count attribute first and injects the text spans afterwards, and
 * carousels and filtered grids render badges long after load — so the observer reacts to
 * any DOM change rather than only to nodes that already carry the count.
 */
(function () {
  'use strict';

  var COUNT_SELECTOR = '[data-number-of-reviews]';

  var TEXT_SELECTOR = [
    '.jdgm-prev-badge__text',
    '.jdgm-carousel-number-of-reviews',
    '.jdgm-all-reviews-text__text'
  ].join(', ');

  function textElementFor(element) {
    var inner = element.querySelector(TEXT_SELECTOR);

    if (inner) {
      return inner;
    }

    /* Only rewrite the element itself when it holds plain text. The full review widget
       (.jdgm-rev-widg) also carries data-number-of-reviews; setting textContent on it wiped
       its markup and left the reviews section as flat text. */
    if (element.children.length === 0 && /\breviews?\b/i.test(element.textContent)) {
      return element;
    }

    return null;
  }

  function fixOne(element) {
    var count = parseInt(element.getAttribute('data-number-of-reviews'), 10);

    if (isNaN(count)) {
      return;
    }

    var target = textElementFor(element);

    if (!target) {
      return;
    }

    var current = target.textContent;

    if (!/\breviews?\b/i.test(current)) {
      return;
    }

    var word = count > 1 ? 'reviews' : 'review';

    var next = current.replace(/\breviews?\b/gi, function (match) {
      /* Keep whatever capitalisation Judge.me used. */
      return match.charAt(0) === match.charAt(0).toUpperCase()
        ? word.charAt(0).toUpperCase() + word.slice(1)
        : word;
    });

    if (next !== current) {
      target.textContent = next;
    }
  }

  function fixAll() {
    Array.prototype.forEach.call(document.querySelectorAll(COUNT_SELECTOR), fixOne);
  }

  var timer = null;

  function fixSoon() {
    window.clearTimeout(timer);
    timer = window.setTimeout(fixAll, 80);
  }

  function start() {
    fixAll();

    /* Any change can be a badge filling itself in; fixAll is cheap and idempotent, so a
       pass that changes nothing produces no further mutations and the loop settles. */
    new MutationObserver(fixSoon).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews']
    });

    /* Belt and braces for widgets that render in an iframe-ish way or very late. */
    window.addEventListener('load', fixSoon);
    [500, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(fixAll, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
